'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _RequestBook = require('./RequestBook.scss');

var _RequestBook2 = _interopRequireDefault(_RequestBook);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

var tripAction = _interopRequireWildcard(_trip);

var _session = require('redux/modules/session');

var _payment = require('redux/modules/payment');

var _calendar = require('redux/modules/calendar');

var _customize = require('redux/modules/customize');

var _reactRouterRedux = require('react-router-redux');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _SelectPeople = require('../General/FormElements/SelectPeople');

var _SelectPeople2 = _interopRequireDefault(_SelectPeople);

var _LoadingButton = require('components/Loader/LoadingButton');

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _Calendar = require('containers/Calendar/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _helpers = require('utils/helpers');

var _price = require('utils/price');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _payment2 = require('utils/payment');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  RequestBook: {
    displayName: 'RequestBook'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/RequestBook.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Scroll from 'react-scroll';
// const ScrollLink = Scroll.Link;

// import moment from 'moment';
// moment.tz.setDefault('Asia/Bangkok');


var RequestBook = _wrapComponent('RequestBook')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    sessionData: state.session.data,
    // selectedDate: state.calendar.selected.day,
    isLoggedIn: state.session.isLoggedIn,
    creating: state.booking.creating,
    user: state.session.user,
    rates: state.info.exchangeRates,
    isInstant: state.calendar.selected.instant,
    paymentDate: state.payment.date,
    paymentDateStatus: state.payment.dateStatus,
    acceptSwap: state.payment.acceptSwap,
    requesting: state.payment.requesting,
    omitBookingFee: state.info.userConfig.omitBookingFee,
    siteConfigs: state.info.siteConfigs
  };
}, (0, _extends3.default)({}, tripAction, {
  setSessionData: _session.setSessionData,
  setLocalSessionData: _session.setLocalSessionData,
  push: _reactRouterRedux.push,
  setError: _calendar.setError,
  setPaymentField: _payment.setField,
  setPaymentData: _payment.setPaymentData,
  logCustomizeTrip: _customize.logCustomizeTrip,
  logSetDate: _payment.logSetDate,
  logAcceptSwap: _payment.logAcceptSwap,
  logRequest: _payment.logRequest
})), _dec2 = (0, _reactCssModules2.default)(_RequestBook2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RequestBook, _Component);

  function RequestBook(props) {
    (0, _classCallCheck3.default)(this, RequestBook);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RequestBook.__proto__ || (0, _getPrototypeOf2.default)(RequestBook)).call(this, props));

    _this.state = {
      showGuarantee: false
    };

    _this.onClose = function () {
      _this.props.onClose();
    };

    _this.getMaxTravelerOption = function () {
      var max_travelers = _this.props.trip.max_travelers;

      return _lodash2.default.fill(Array(max_travelers)).map(function (item, index) {
        return index + 1;
      });
    };

    _this.getQuantity = function () {
      var _this$props = _this.props,
          trip = _this$props.trip,
          sessionData = _this$props.sessionData;

      if (trip.is_per_day !== true) {
        return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
      }
      return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
    };

    _this.setDate = function (date, status) {
      // this.props.setSessionData({'date': date});
      _this.props.setPaymentField('date', date);
      _this.props.setPaymentField('dateStatus', status);
      _this.props.setPaymentField('isInstant', status === 'available');
      _this.props.logSetDate(date, status);
    };

    _this.openChat = function () {
      _this.props.onOpenChat();
      var _this$props2 = _this.props,
          trip = _this$props2.trip,
          paymentDate = _this$props2.paymentDate;

      var data = {
        tripId: trip._id,
        quantity: _this.getQuantity(),
        date: paymentDate,
        requestType: 'message',
        device: 'desktop'
      };
      _this.props.logRequest(data);
    };

    _this.toggleGuarantee = function () {
      _this.setState({ showGuarantee: !_this.state.showGuarantee });
    };

    _this.requestForm = function () {
      _this.props.logCustomizeTrip('desktop', _this.props.trip._id);
      _this.props.push('/customize/' + _this.props.trip.slug);
    };

    _this.requestBook = function () {
      var _this$props3 = _this.props,
          trip = _this$props3.trip,
          paymentDate = _this$props3.paymentDate;

      var quantity = _this.getQuantity();
      var paymentData = {
        trip: trip,
        quantity: quantity,
        date: paymentDate,
        requestType: 'book',
        device: 'desktop'
      };
      var data = {
        tripId: trip._id,
        quantity: quantity,
        date: paymentDate,
        requestType: 'book',
        device: 'desktop'
      };
      _this.props.logRequest(data);
      _this.props.setPaymentData(paymentData);
      _this.props.push((0, _payment2.parseDataToQuery)(paymentData));
    };

    _this.toggleAcceptSwap = _this.toggleAcceptSwap.bind(_this);

    if (!(typeof _this.toggleAcceptSwap === 'function')) {
      throw new TypeError('Value of "this.toggleAcceptSwap" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.toggleAcceptSwap));
    }

    return _this;
  }

  (0, _createClass3.default)(RequestBook, [{
    key: 'onChange',
    value: function onChange(name, value, a) {
      this.props.setLocalSessionData({ 'quantity': a });
      this.props.setSessionData({ 'quantity': a });
    }
  }, {
    key: 'toggleAcceptSwap',
    value: function toggleAcceptSwap() {
      this.props.setPaymentField('acceptSwap', !this.props.acceptSwap);
      this.props.logAcceptSwap(!this.props.acceptSwap);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // const { trip, sessionData, rates, user, isInstant, paymentDate, paymentDateStatus, omitBookingFee, siteConfigs, acceptSwap, requesting, p2pReview } = this.props;
      var _props = this.props,
          trip = _props.trip,
          sessionData = _props.sessionData,
          rates = _props.rates,
          user = _props.user,
          isInstant = _props.isInstant,
          paymentDate = _props.paymentDate,
          paymentDateStatus = _props.paymentDateStatus,
          omitBookingFee = _props.omitBookingFee,
          siteConfigs = _props.siteConfigs,
          acceptSwap = _props.acceptSwap,
          requesting = _props.requesting;
      var currency = sessionData.currency;

      var quantity = this.getQuantity();
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'div',
          { styleName: 'calendar-action-container' },
          trip.is_request_form !== true && [_react3.default.createElement(_Calendar2.default, { tripAvailability: true, trip: trip, initialDate: paymentDate, onChange: this.setDate, offsetDay: 1, allowBookOnNA: trip.is_replaceable, key: 'req-0' }), _react3.default.createElement(
            'div',
            { styleName: 'checkbox-container', style: paymentDateStatus === 'n/a' ? null : { display: 'none' }, key: 'req-1' },
            _react3.default.createElement('div', { styleName: acceptSwap ? 'checkbox-checked' : 'checkbox', onClick: this.toggleAcceptSwap }),
            _react3.default.createElement(
              'span',
              { styleName: acceptSwap ? 'checkbox-label-checked' : 'checkbox-label', onClick: this.toggleAcceptSwap },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'payment.payment_general.accept_swap.label' })
            )
          )],
          trip.is_per_day !== true && _react3.default.createElement(
            'div',
            { styleName: 'max-travelers-container' },
            _react3.default.createElement('i', { styleName: 'max-travelers-icon' }),
            _react3.default.createElement(
              'span',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.guest' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'input-container' },
              _react3.default.createElement(_SelectPeople2.default, { options: this.getMaxTravelerOption(), value: quantity > trip.max_travelers ? trip.max_travelers : quantity, onChange: this.onChange.bind(this), fieldName: 'quantity' })
            )
          ),
          trip.is_per_day !== true && _react3.default.createElement(
            'div',
            { styleName: 'price-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'price-label' },
              _react3.default.createElement('i', { styleName: 'price-per-person-icon' }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.price' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'price-detail' },
              _react3.default.createElement(
                'span',
                { styleName: 'price' },
                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates)),
                ' ',
                siteConfigs.fixYuan ? '元' : currency
              )
            )
          ),
          trip.is_per_day !== true && _react3.default.createElement(
            'div',
            { styleName: 'price-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'price-label' },
              _react3.default.createElement('i', { styleName: 'price-icon' }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.total_price' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'price-detail' },
              trip.discount_percentage > 0 && _react3.default.createElement(
                'span',
                { styleName: 'percent-off' },
                trip.discount_percentage * 100,
                '%OFF'
              ),
              _react3.default.createElement(
                'span',
                { styleName: 'price' },
                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates) * quantity),
                ' ',
                siteConfigs.fixYuan ? '元' : currency
              ),
              trip.discount_percentage > 0 && _react3.default.createElement(
                'span',
                { styleName: 'cross-price' },
                _react3.default.createElement(
                  'span',
                  null,
                  (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplaySeasonedPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates) * quantity),
                  ' ',
                  siteConfigs.fixYuan ? '元' : currency
                )
              )
            )
          ),
          trip.is_per_day === true && _react3.default.createElement(
            'div',
            { styleName: 'price-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'price-label' },
              _react3.default.createElement('i', { styleName: 'price-icon' }),
              _react3.default.createElement(
                'span',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.book.price_per_day' })
              )
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'price-detail' },
              _react3.default.createElement(
                'span',
                { styleName: 'price' },
                (0, _helpers.commaizeInt)((0, _price.ceil)((0, _helpers.getDisplayPrice)(quantity, trip.full_prices, omitBookingFee), currency, rates)),
                ' ',
                siteConfigs.fixYuan ? '元' : currency,
                '/',
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.head.day' })
              )
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'action-container' },
            _react3.default.createElement(
              'p',
              { styleName: 'guarantee' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed' }),
              ' ',
              _react3.default.createElement('i', { styleName: 'question-mark', 'data-tip': true, 'data-for': 'guarantee' })
            ),
            _react3.default.createElement(
              _reactTooltip2.default,
              { id: 'guarantee', place: 'bottom', type: 'light', effect: 'solid', border: true },
              _react3.default.createElement(
                'div',
                { styleName: 'tooltip-header-container' },
                _react3.default.createElement('i', { styleName: 'inspiration-icon' }),
                _react3.default.createElement(
                  'span',
                  { styleName: 'tooltip-header' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed' })
                )
              ),
              _react3.default.createElement(
                'p',
                { styleName: 'tooltip-content' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.desktop.guaranteed.description', values: { lineBreak: _react3.default.createElement('br', null) } })
              )
            ),
            function () {
              if (trip.is_request_form === true) {
                return false;
              }
              if (user && user._id === trip.user_id._id) {
                return _react3.default.createElement(
                  'a',
                  { styleName: 'btn-request-disable' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
                );
              } else if (requesting) {
                return _react3.default.createElement(
                  'a',
                  { styleName: 'btn-request-loading' },
                  _react3.default.createElement(_LoadingButton2.default, null),
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.loading' })
                );
              }
              if (siteConfigs.showLineAddAndFacebookMessage) return null;
              return _react3.default.createElement(
                'a',
                { styleName: 'btn-request', onClick: _this2.requestBook },
                isInstant ? _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.instant_book' }) : _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.book' })
              );
            }(),
            function () {
              if (trip.is_request_form === true) {
                return false;
              }
              if (siteConfigs.showLineAddAndFacebookMessage) {
                if (user && user._id === trip.user_id._id) {
                  return [_react3.default.createElement(
                    'a',
                    { styleName: 'btn-chat-facebook-disabled', target: '_blank', href: 'https://www.facebook.com/messages/t/pachantiew' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
                  ), _react3.default.createElement(
                    'a',
                    { styleName: 'btn-chat-line-disabled', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
                  )];
                }
                return [_react3.default.createElement(
                  'a',
                  { styleName: 'btn-chat-facebook', target: '_blank', href: 'https://www.facebook.com/messages/t/pachantiew' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_fb_message' })
                ), _react3.default.createElement(
                  'a',
                  { styleName: 'btn-chat-line', target: '_blank', href: 'https://line.me/R/ti/p/%40rol5201y' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_line_message' })
                )];
              }
              if (user && user._id === trip.user_id._id) {
                return _react3.default.createElement(
                  'a',
                  { styleName: 'btn-chat-disable' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
                );
              }
              return _react3.default.createElement(
                'a',
                { styleName: 'btn-chat', onClick: _this2.openChat },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.send_message' })
              );
            }()
          )
        )
      );
    }
  }]);
  return RequestBook;
}(_react2.Component), _class2.propTypes = {
  onClose: _react2.PropTypes.func,
  onOpenChat: _react2.PropTypes.func,
  rates: _react2.PropTypes.object,
  sessionData: _react2.PropTypes.object,
  trip: _react2.PropTypes.object,
  setSessionData: _react2.PropTypes.func,
  setLocalSessionData: _react2.PropTypes.func,
  // selectedDate: PropTypes.object,
  push: _react2.PropTypes.func,
  isLoggedIn: _react2.PropTypes.bool,
  creating: _react2.PropTypes.bool,
  user: _react2.PropTypes.object,
  isInstant: _react2.PropTypes.bool,
  setError: _react2.PropTypes.func,
  paymentDate: _react2.PropTypes.any,
  paymentDateStatus: _react2.PropTypes.string,
  // p2pReview: PropTypes.bool,
  setPaymentField: _react2.PropTypes.func,
  setPaymentData: _react2.PropTypes.func,
  requesting: _react2.PropTypes.bool,
  logCustomizeTrip: _react2.PropTypes.func,
  omitBookingFee: _react2.PropTypes.bool,
  siteConfigs: _react2.PropTypes.object,
  acceptSwap: _react2.PropTypes.bool,
  logSetDate: _react2.PropTypes.func,
  logAcceptSwap: _react2.PropTypes.func,
  setTripDate: _react2.PropTypes.func,
  logRequest: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = RequestBook;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/RequestBook.js
// module id = 1643
// module chunks = 0